import { ICONS } from './UiIcon.constants';
import type { UiIconProps } from './UiIcon.types';
import { cn } from '@/lib/tailwind';

export function UiIcon({ name, ...props }: UiIconProps) {
    const Icon = ICONS[name];
    return <Icon {...props} className={cn('size-full', props.className)} />;
}

export default UiIcon;
